import { useEffect, useState } from 'react';
import { fetchLandingStats } from './api/publicApi';

const Herosection = () => {
  const [stats, setStats] = useState({ flws: 526, courses: 10 });

  useEffect(() => {
    const controller = new AbortController();
    fetchLandingStats(controller.signal)
      .then((result) => {
        if (result?.data) {
          setStats({
            flws: result.data.flws ?? 526,
            courses: result.data.courses ?? 10,
          });
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <section className='bg-orange-50 space-y-4 py-16 px-6 md:px-12 overflow-x-visible'>
      <div className='flex flex-col mt-16 ml-0 lg:ml-20 lg:flex-row items-center justify-between overflow-visible'>
        {/* Left Section */}
        <div className='lg:w-1/2 text-center lg:text-left space-y-6 ml-0 lg:ml-20'>
          <button className='text-sm font-raleway text-orange-300 bg-white border shadow-md rounded-md px-4 py-1'>
            Learn & Get Certificate
          </button>
          <h1 className='text-4xl md:text-5xl  font-Anton text-orange-900 leading-tight'>
            Free Online & Offline <br /> Courses with The <br /> EnRich Digital
            <br /> elearning App
          </h1>
          <p className='text-orange-900 text-base font-raleway'>
            Achieving Your Dreams Through Education
          </p>

         
        </div>

        {/* Right Section */}
        <div className='lg:w-1/2 relative mt-6 lg:mt-0 flex justify-center items-start overflow-visible'>
          <div className='relative xl:w-[327px] xl:h-[592px]  lg:w-[327px] lg:h-[593px] md:w-[227px] md:h-[423px] w-[127px] h-[302px] overflow-visible'>
            {/* Background */}
            <div className='absolute xl:w-[327px] xl:h-[593px]  lg:w-[327px] lg:h-[593px] md:w-[227px] md:h-[423px] w-[127px] h-[302px]  top-[7px]  xl:left-0 lg:left-0 md:left-[-50px] left-[80px] '>
              <img
                src='./ring.png'
                alt='Hero Background'
                className='w-full h-full object-cover'
              />
            </div>

            {/* Thumb */}
            <img
              src='./Thumb.png'
              alt='Thumb'
              className='absolute top-[0px] left-[84px] lg:left-2 w-full h-full z-10 object-cover'
            />

            {/* 2k+ Student Badge */}
            <div className='absolute z-20 top-[30px]  xl:w-40 lg:w-40 md:w-32 w-16 xl:right-56 flex items-center space-x-2 bg-white shadow-md rounded-full px-4'>
              <div>
                <p className='text-lg font-Anton text-orange-400'>{stats.flws}</p>
                <p className='text-base font-Anton text-orange-900'>FLWs</p>
              </div>
              <img
                src='./strive.png'
                alt='Badge'
                className='w-16 h-12 object-contain'
              />
            </div>

            {/* 10+ Success Courses Badge */}
            <div className='absolute z-10 bottom-[47px] lg:right-[-110px] md:right-[-50px] sm:right-[-150px] w-[167px] h-[72px] bg-white shadow-md rounded-full px-7 py-3 flex flex-col text-left'>
              <p className='text-orange-400  font-Anton text-2xl'>{stats.courses}+</p>
              <p className='text-orange-900 text-xs font-raleway'>
                Success Courses
              </p>
            </div>

            <div className='absolute z-10 bottom-[-50px] sm:bottom-[-60px] lg:right-[-70px] md:right-[-50px] sm:right-[-109px] w-[106px] h-[57px]'>
              <img
                src='./wrig.png'
                alt='Hijab'
                className='w-full h-full object-cover'
              />
            </div>

            <div className='absolute z-10 top-[0px] right-[-80px] md:right-[-40px] sm:right-[-100px] w-[28px] h-[28px]'>
              <img
                src='./Button 2.png'
                alt='Hijab'
                className='w-full h-full object-cover'
              />
            </div>

            {/* Thumb 2 */}
            <div className='absolute top-[210px] lg:left-0 md:left-[-150px] sm:left-[120px] w-[237px] h-[429px] z-20'>
              <img
                src='./cover.png'
                alt='Thumb 2 Background'
                className='absolute top-[7px] left-[-265px] w-full h-full object-cover'
              />
              <img
                src='./Thumb 2.png'
                alt='Small Portrait'
                className='absolute top-0 left-[-257px] w-full h-full z-10 object-cover'
              />
              <div className='absolute z-10 top-[-34px] left-[-278px] w-[15px] h-[15px]'>
                <img
                  src='./Button.png'
                  alt='Button 1'
                  className='w-full h-full object-cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Herosection;
